import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-intropon-poster',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-intropon-poster.component.scss']
})
export class NestedSidebarIntroponPosterComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  pdf = {
    pdfTitle: 'Introduction to<br>Passive Optical Networks (PON) Poster',
    pdfimg: './assets/images/sidebar/Poster_PON_D99-00-015P_B00.webp',
    url: 'intropon',
    opt: 'BUTTON.DOWNLOADREQ',
    width: '1728',
    height: '1152'
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
  }

}
